import React, { useState, useEffect } from 'react';

// === DATA ===
const services = [
  { name: 'Hair Styling', price: '₹499+', desc: 'Expert cuts, styling, and modern coloring.', icon: '✂️', img: 'https://images.unsplash.com/photo-1596178060671-7a80dc8059ea?q=80&w=400&auto=format&fit=crop' },
  { name: 'Skin Care', price: '₹799+', desc: 'Facials, cleanups, and glow treatments.', icon: '💆‍♀️', img: 'https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?q=80&w=400&auto=format&fit=crop' },
  { name: 'Makeup Arts', price: '₹1499+', desc: 'Bridal, party, and occasion makeup.', icon: '💄', img: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?q=80&w=400&auto=format&fit=crop' },
  { name: 'Grooming', price: '₹299+', desc: 'Shaving, beard trim, and men\'s styling.', icon: '🧔', img: 'https://images.unsplash.com/photo-1621605815971-fbc98d665033?q=80&w=400&auto=format&fit=crop' },
];

const galleryImages = [
  'https://images.unsplash.com/photo-1633681926022-84c23e8cb2d6?q=80&w=400&auto=format&fit=crop', 
  'https://greenroomrva.com/wp-content/uploads/2023/06/JSP8970-1536x1025.jpg', 
  'https://images.pexels.com/photos/705255/pexels-photo-705255.jpeg?cs=srgb&dl=inside-window-ceiling-705255.jpg&fm=jpg', 
  'https://www.diamondspa46.com/wp-content/uploads/2022/09/gallery03.jpg', 
  'https://www.janetbesthairdesign.co.uk/wp-content/uploads/2023/10/in-salon-bspoke-bridal-hairdressers-1024x683.jpg', 
  'https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?q=80&w=400&auto=format&fit=crop', 
];

// === COMPONENT ===
const SalonPremiumPage: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Navbar scroll effect
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle Form Submission Demo
  const handleBookingSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => {
      setIsModalOpen(false);
      setIsSubmitted(false); // Reset for next time
    }, 3000); // Close popup after 3 seconds
  };

  return (
    <div className="min-h-screen bg-[#FDFCFB] text-zinc-900 font-sans antialiased overflow-x-hidden relative">
      
      {/* === BOOKING MODAL (POPUP) === */}
      {isModalOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-zinc-950/60 backdrop-blur-sm animate-fadeIn">
          <div className="bg-white rounded-3xl p-6 md:p-8 max-w-md w-full relative animate-slideUp shadow-2xl">
            {/* Close Button */}
            <button 
              onClick={() => setIsModalOpen(false)} 
              className="absolute top-4 right-4 text-zinc-400 hover:text-zinc-900 text-2xl transition"
            >
              &times;
            </button>

            {!isSubmitted ? (
              <>
                <div className="mb-6">
                  <h3 className="text-3xl font-serif font-medium text-zinc-950">Book a Session</h3>
                  <p className="text-zinc-500 text-sm mt-1">Fill the details and we'll confirm your slot.</p>
                </div>
                
                <form onSubmit={handleBookingSubmit} className="space-y-4">
                  <div>
                    <label className="block text-xs font-semibold text-zinc-600 uppercase tracking-wide mb-1">Full Name</label>
                    <input required type="text" placeholder="John Doe" className="w-full px-4 py-3 rounded-xl border border-zinc-200 focus:border-amber-900 focus:ring-1 focus:ring-amber-900 outline-none transition" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-zinc-600 uppercase tracking-wide mb-1">Phone Number</label>
                    <input required type="tel" placeholder="+91 00000 00000" className="w-full px-4 py-3 rounded-xl border border-zinc-200 focus:border-amber-900 focus:ring-1 focus:ring-amber-900 outline-none transition" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-zinc-600 uppercase tracking-wide mb-1">Select Service</label>
                    <select className="w-full px-4 py-3 rounded-xl border border-zinc-200 focus:border-amber-900 focus:ring-1 focus:ring-amber-900 outline-none transition bg-white">
                      <option>Hair Cut & Styling</option>
                      <option>Facial & Skin Care</option>
                      <option>Bridal / Party Makeup</option>
                      <option>General Grooming</option>
                    </select>
                  </div>
                  <button type="submit" className="w-full bg-zinc-950 text-white font-semibold py-4 rounded-xl mt-4 hover:bg-amber-900 transition-colors shadow-lg active:scale-[0.98]">
                    Confirm Appointment
                  </button>
                </form>
              </>
            ) : (
              // Success State
              <div className="text-center py-10 animate-fadeIn">
                <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center text-4xl mx-auto mb-5">
                  ✓
                </div>
                <h3 className="text-2xl font-serif font-medium text-zinc-950 mb-2">Booking Requested!</h3>
                <p className="text-zinc-600">We have received your details. Our team will call you shortly to confirm the exact time.</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* 1. Header/Navbar */}
      <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-lg py-3' : 'bg-transparent py-6'}`}>
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          <a href="#" className="flex items-center gap-2 group">
            <span className="text-3xl text-amber-800 transition-transform group-hover:scale-110">✨</span>
            <span className={`text-3xl font-bold transition-colors font-serif ${isScrolled ? 'text-zinc-950' : 'text-zinc-950'}`}>
              The <span className="font-light text-amber-900">Aura</span>
            </span>
          </a>
          
          <div className="hidden md:flex items-center gap-8 text-sm font-medium uppercase tracking-widest">
            {['Services', 'Gallery', 'Visit'].map(item => (
              <a href={`#${item.toLowerCase()}`} key={item} className="relative group overflow-hidden text-zinc-800">
                <span className="block group-hover:-translate-y-full transition-transform duration-300">{item}</span>
                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-amber-800 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
                <span className="block absolute top-0 left-0 group-hover:translate-y-0 translate-y-full transition-transform duration-300 text-amber-900">{item}</span>
              </a>
            ))}
          </div>

          <button 
            onClick={() => setIsModalOpen(true)}
            className="bg-amber-950 text-white px-7 py-3 rounded-full text-xs font-bold uppercase tracking-widest hover:bg-amber-800 transition-all duration-300 active:scale-95 shadow-lg shadow-amber-950/20"
          >
            Book Now
          </button>
        </div>
      </nav>

      {/* 2. Hero Section */}
      <header className="relative pt-32 pb-24 md:pt-48 md:pb-36 bg-white overflow-hidden border-b border-zinc-100">
        <div className="absolute inset-0 z-0 opacity-10">
            <img src="https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?q=80&w=2000&auto=format&fit=crop" alt="bg" className="w-full h-full object-cover fixed"/>
        </div>
        
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-12 gap-12 items-center relative z-10">
          <div className="md:col-span-7 space-y-7 animate-fadeInLeft">
            <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-100 px-4 py-1 rounded-full">
              <span className="animate-pulse">✨</span>
              <span className="text-sm font-semibold text-amber-950 uppercase tracking-widest">Premium Beauty Experience</span>
            </div>
            
            <h1 className="text-6xl md:text-8xl font-serif font-medium text-zinc-950 leading-tight">
              Reinvent Your <br /> <span className="italic text-amber-900 relative">Style<span className="absolute bottom-1 left-0 w-full h-3 bg-amber-200 -z-10 rounded-full"></span></span>.
            </h1>
            
            <p className="text-xl text-zinc-700 max-w-xl leading-relaxed">
              Step into The Aura Salon, where luxury care meets expert artistry. Explore personalized grooming that leaves you feeling transformed.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-5 pt-6">
              <button onClick={() => setIsModalOpen(true)} className="bg-zinc-950 text-white text-center px-10 py-4 rounded-full font-semibold hover:bg-amber-900 transition-all duration-300 shadow-xl shadow-zinc-950/10">
                Book Appointment
              </button>
              <a href="#gallery" className="border-2 border-zinc-200 text-zinc-900 text-center px-10 py-4 rounded-full font-semibold hover:border-amber-900 hover:text-amber-900 transition-all duration-300">
                View Portfolio
              </a>
            </div>
          </div>

          <div className="md:col-span-5 relative animate-fadeInRight delay-100">
            <div className="aspect-[3/4] rounded-3xl overflow-hidden shadow-2xl shadow-zinc-950/10 border-4 border-white">
              <img src="https://www.miracolasalon.com/wp-content/uploads/2023/08/w4.jpg" alt="Model" className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
            </div>
            <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-amber-100 rounded-full -z-10 blur-xl"></div>
          </div>
        </div>
      </header>

      {/* 3. Services Section */}
      <section id="services" className="py-28 px-6 bg-[#FDFCFB]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20 space-y-4 max-w-3xl mx-auto">
            <span className="text-sm font-bold text-amber-900 uppercase tracking-widest">What We Offer</span>
            <h2 className="text-5xl md:text-6xl font-serif font-medium text-zinc-950">Curated Beauty Services</h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-3xl border border-zinc-100 group transition-all duration-500 hover:shadow-2xl hover:shadow-amber-950/5 hover:-translate-y-2 flex flex-col items-center text-center">
                <div className="aspect-square w-full rounded-2xl overflow-hidden mb-7 relative">
                    <img src={service.img} alt={service.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"/>
                </div>
                <span className="text-5xl mb-5 transition-transform duration-300 group-hover:scale-110">{service.icon}</span>
                <h3 className="text-2xl font-serif font-semibold text-zinc-950 mb-3">{service.name}</h3>
                <p className="text-zinc-600 mb-6 flex-grow">{service.desc}</p>
                <div className="mt-auto pt-6 border-t border-zinc-100 w-full">
                  <span className="text-3xl font-bold text-amber-950">{service.price}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 4. Gallery Section */}
      <section id="gallery" className="py-28 px-6 bg-zinc-950 text-zinc-100 overflow-hidden relative">
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-20 gap-8">
            <div className="space-y-4 max-w-2xl">
              <span className="text-sm font-bold text-amber-400 uppercase tracking-widest">Our Work</span>
              <h2 className="text-5xl md:text-6xl font-serif font-medium text-white">Style In Action</h2>
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
            {galleryImages.map((img, index) => (
              <div key={index} className="aspect-square bg-zinc-800 rounded-3xl overflow-hidden group shadow-lg relative">
                <img src={img} alt={`Gallery ${index}`} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 5. Contact & Map Section (UPDATED) */}
      <section id="visit" className="py-28 px-6 bg-[#FDFCFB]">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center">
          <div className="space-y-8 animate-fadeInLeft">
            <div className="space-y-3">
              <span className="text-sm font-bold text-amber-900 uppercase tracking-widest">Contact Us</span>
              <h2 className="text-5xl md:text-6xl font-serif font-medium text-zinc-950">Visit The Aura</h2>
            </div>
            
            <div className="space-y-6 pt-4 text-lg">
                <div className="flex gap-4 items-start p-6 bg-white rounded-2xl border border-zinc-100 hover:border-amber-100 transition-colors duration-300">
                    <span className="text-3xl mt-1">📍</span>
                    <div>
                        <p className="font-semibold text-zinc-950">Address</p>
                        <p className="text-zinc-600 text-base mt-1">Shop 45, Aura Towers, Near Clock Tower, Ghaziabad, UP 201001</p>
                    </div>
                </div>
                <div className="flex gap-4 items-center p-6 bg-white rounded-2xl border border-zinc-100 hover:border-amber-100 transition-colors duration-300">
                    <span className="text-3xl">📞</span>
                    <div>
                        <p className="font-semibold text-zinc-950">Phone</p>
                        <a href="tel:+919876543210" className="text-amber-950 font-bold hover:text-amber-800 transition">+91 98765 43210</a>
                    </div>
                </div>
            </div>
          </div>

          {/* REAL MAP EMBED */}
          <div className="w-full h-[450px] bg-zinc-200 rounded-3xl overflow-hidden shadow-2xl shadow-zinc-950/10 animate-fadeInRight delay-100 relative group border-4 border-white">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d112032.50293113117!2d77.36988891338876!3d28.667236544838634!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cf1bb41c50fdf%3A0xe6f06fd26a7798ba!2sGhaziabad%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin" 
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen={false} 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              className="grayscale group-hover:grayscale-0 transition-all duration-700 ease-in-out"
            ></iframe>
            {/* Overlay Badge */}
            <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg border border-zinc-100 text-sm font-bold text-amber-950 flex items-center gap-2 pointer-events-none transition-transform group-hover:scale-105">
              <span>📍</span> Find us here
            </div>
          </div>
        </div>
      </section>

      {/* 6. Footer */}
      <footer className="py-10 px-6 bg-zinc-100 text-zinc-600 border-t border-zinc-200">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-2 group">
                <span className="text-2xl text-amber-800">✨</span>
                <span className="text-xl font-bold font-serif text-zinc-950">The Aura</span>
            </div>
            <p className='text-sm text-center'>&copy; {new Date().getFullYear()} The Aura Salon.</p>
        </div>
      </footer>

      {/* CSS Animations */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes fadeInLeft {
          from { opacity: 0; transform: translateX(-30px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes fadeInRight {
          from { opacity: 0; transform: translateX(30px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px) scale(0.95); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        .animate-fadeInLeft { animation: fadeInLeft 1s ease-out forwards; }
        .animate-fadeInRight { animation: fadeInRight 1s ease-out forwards; }
        .animate-fadeIn { animation: fadeIn 0.3s ease-out forwards; }
        .animate-slideUp { animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
        .delay-100 { animation-delay: 0.1s; }
      `}} />
    </div>
  );
};

export default SalonPremiumPage;